import { render } from "./warning-stt-cod.vue?vue&type=template&id=54a73d22&ts=true"
import script from "./warning-stt-cod.vue?vue&type=script&lang=ts"
export * from "./warning-stt-cod.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__